import UserRoleSelect from './UserRoleSelect';

export default UserRoleSelect;
